var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useContext, useRef, useState } from 'react';
import { ValidatorProvider } from "react-admin-base";
import { FormattedMessage } from 'react-intl';
import { Navigate, Routes, useParams, Route } from 'react-router-dom';
import { Alert, Button, Col, Form, Modal, ModalFooter, ModalHeader, Row } from "reactstrap";
import LoadingButton from '../Components/LoadingButton';
import BootstrapDataTable, { Actions } from './BootstrapDataTable';
export function ModalEntityEditor({ entity, title, size, url, onReload, disabled, children }) {
    const [, , save, loading] = entity;
    const [open, setOpen] = useState(true);
    const [saved, setSaved] = useState(false);
    const [error, setError] = useState(false);
    const onSubmit = useCallback(function (e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.stopPropagation();
            e.preventDefault();
            if (saved) {
                setSaved(false);
            }
            if (error) {
                setError(null);
            }
            try {
                let data = yield save();
                if (onReload) {
                    yield onReload(data);
                }
                if (url) {
                    setSaved(true);
                }
            }
            catch (e) {
                console.error(e);
                setError((e.response && e.response.data && e.response.data.message) || (error.data && error.data.message) || e.data || e.message || e);
            }
            finally {
            }
        });
    }, [save, saved, error, onReload, url]);
    return React.createElement(React.Fragment, null,
        (saved || !open) && url && React.createElement(Navigate, { to: url, replace: true }),
        React.createElement(Modal, { isOpen: true, size: size, toggle: () => url ? setOpen(false) : onReload(null), fade: false },
            title && React.createElement(ModalHeader, { toggle: () => url ? setOpen(false) : onReload(null) },
                React.createElement("b", null, title)),
            React.createElement(ValidatorProvider, null,
                React.createElement(Form, { onSubmit: onSubmit, disabled: !!loading || disabled },
                    React.createElement("fieldset", { disabled: !!loading || !!disabled }, children),
                    React.createElement(ModalFooter, null,
                        error && React.createElement(Alert, { color: "danger", toggle: () => setError(null), style: { display: 'block', width: '100%' } }, error),
                        React.createElement(Row, { className: "w-100" },
                            React.createElement(Col, null,
                                React.createElement(LoadingButton, { block: true, loading: loading, type: "submit", color: "primary" },
                                    React.createElement("i", { className: "fas fa-save" }),
                                    ' ',
                                    React.createElement(FormattedMessage, { id: "ENTITY.SAVE" }))),
                            React.createElement(Col, null,
                                React.createElement(Button, { block: true, outline: true, color: "danger", onClick: (e) => { e.preventDefault(); (url ? setOpen(false) : onReload(null)); } },
                                    React.createElement("i", { className: "fas fa-times-circle" }),
                                    ' ',
                                    React.createElement(FormattedMessage, { id: "ENTITY.CANCEL" })))))))));
}
const UrlContext = React.createContext(null);
export function CRUDActions({ id, edit, del, children }) {
    const url = useContext(UrlContext);
    return React.createElement(Actions, { edit: edit && (url + "/" + id + "/edit"), del: del }, children);
}
function ComponentWrapper(_a) {
    var { Component } = _a, props = __rest(_a, ["Component"]);
    const { id } = useParams();
    return React.createElement(Component, Object.assign({}, props, { id: id }));
}
export default function CRUD(props) {
    const ref = useRef(null);
    const { url, apiUrl, Component, defaultParams, noAdd } = props;
    var reload = useCallback(function () {
        return __awaiter(this, void 0, void 0, function* () {
            if (ref.current) {
                ref.current({});
            }
        });
    }, [ref]);
    return React.createElement(UrlContext.Provider, { value: url },
        React.createElement(Routes, null,
            !noAdd && React.createElement(Route, { path: "create", element: React.createElement(ComponentWrapper, Object.assign({ Component: Component, url: url, onReload: reload }, (defaultParams || {}))) }),
            React.createElement(Route, { path: ":id/edit", element: React.createElement(ComponentWrapper, Object.assign({ Component: Component, url: url, onReload: reload }, (defaultParams || {}))) })),
        React.createElement(BootstrapDataTable, Object.assign({ innerRef: ref, add: !noAdd && "create" }, props, { url: apiUrl || url })));
}
